export default __webpack_public_path__ + "static/media/js-in-js.8bf9e97a.jpeg";